import request from 'reqwest';
import when from 'when';
import CustomerConstants from '../constants/CustomerConstants';
import AuthService from '../services/AuthService';

class CustomerService {
  list(filter) {
    return when(request({
      url: CustomerConstants.CUSTOMER_URL,
      method: 'GET',
      crossOrigin: true,
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      data: filter
    }));
  }
  getCount() {
    return when(request({
      url: CustomerConstants.CUSTOMER_URL + 'count',
      method: 'GET',
      crossOrigin: true,
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      contentType: 'application/json',
      withCredentials: true,
      type: 'json'
    }));
  }
}

export default new CustomerService()



/** WEBPACK FOOTER **
 ** ./src/services/CustomerService.js
 **/